module.exports = __webpack_public_path__ + "img/registration-main-bg.b75393dd.png";